import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./ParlamentoJuvenil.css";

const ParticipationStep = ({ step }) => <li>{step}</li>;

export const ParlamentoJuvenil = () => {
  useEffect(() => {
    document.title = `Parlamento Juvenil`;
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[{ label: "Cultura Cívica" }, { label: "Parlamento Juvenil" }]}
      />

      <div className="margin-bottom-2">
        <TitlePages title="Cultura Cívica" subTitle="Parlamento Juvenil" />

        <div className="ContenidoCivica">
          <p>
            El Instituto Tlaxcalteca de Elecciones colabora con el Congreso del
            Estado y el Instituto Tlaxcalteca de la Juventud, para convocar a las
            juventudes tlaxcaltecas a participar en la edición anual del
            parlamento juvenil, en el cual se escucha la voz de las y los jóvenes
            a través de sus propuestas de iniciativa o reformas y ensayos. La
            edición anual del parlamento juvenil
          </p>
          <h3>¿Cómo participar?</h3>
          <ol className="civica-steps-list">
            <ParticipationStep step="Revisar la convocatoria que emita la Comisión Organizadora." />
            <ParticipationStep step="Tener entre 16 y 29 años, en caso de se mayor de edad, presentar copia de credencial de elector del participante, de lo contario copia de la credencial de elector del padre, madre o tutor/a de la persona joven participante, comprobante de domicilio con vigencia no mayor a sesenta días." />
            <ParticipationStep step="Realizar un escrito dirigido a la Comisión Organizadora, en la que deberán señalar los motivos por los que desea participar en el Parlamento Juvenil." />
            <ParticipationStep step="En caso de que la persona joven participante sea menor de edad, deberá presentar un escrito de autorización del padre, madre o tutor/a." />
            <ParticipationStep step="Reunir los requisitos y presentarlos ante el Congreso del Estado o en la Dirección del Organización Electoral, Capacitación y Educación Cívica del ITE." />
          </ol>

          <div className="civica-contacto">
            <h3>Datos de contacto:</h3>
            <p>
              Dirección de Organización Electoral, Capacitación y Educación Cívica
              <br /> Ex – Fábrica San Manuel S/N, Barrio Nuevo, C.P. 90640, San
              Miguel Contla, Santa Cruz Tlaxcala, Tlaxcala.
              <br />
              Correo electrónico:{" "}
              <a
                href="mailto:organizacionelectoral@itetlax.org.mx"
                className="civica-email-link"
              >
                organizacionelectoral@itetlax.org.mx
              </a>
              <br />
              Tel. 246 46 50340 ext. 105 y 106
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParlamentoJuvenil;

ParticipationStep.propTypes = {
  step: PropTypes.string.isRequired,
};
